<script setup lang="ts">
// Sierra's .toast: inverted (foreground on background), bold, with a dot in its tone
// unless it's neutral. The caller mounts, positions and dismisses it.
import type { Tone } from '../types.ts';

withDefaults(defineProps<{ message?: string; tone?: Tone }>(), { message: '', tone: 'neutral' });
</script>

<template>
  <div class="itc-toast" role="status">
    <span v-if="tone !== 'neutral'" class="itc-toast__dot" :class="`t-${tone}`" aria-hidden="true"></span>
    <span class="itc-toast__msg"><slot>{{ message }}</slot></span>
  </div>
</template>

<style scoped>
.itc-toast {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  max-width: 100%;
  padding: 10px 16px;
  border-radius: var(--itc-r-control);
  background: var(--itc-fg);
  color: var(--itc-bg);
  font-weight: 700;
}
.itc-toast__dot {
  width: 8px;
  height: 8px;
  flex-shrink: 0;
  border-radius: 50%;
  background: currentColor;
}
.itc-toast__msg {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
</style>
